import React, { useState } from 'react';
import ClientSidebar from '../ClientSidebar';
import ClientBottomNav from '../ClientBottomNav';
import ProductShell from '../product/ProductShell';
import { ClientPageHeader, ClientGuideCallout } from '../../client/guidance';
import { CLIENT_PAGE_GUIDES } from '../../../utils/clientPageGuides';

/**
 * Authenticated client account shell.
 * Header + guide sit in the main column beside the sidebar.
 */
const ClientPageLayout = ({
  children,
  title = 'My Account',
  subtitle = null,
  actions = null,
  guideKey = null,
  guideTone = 'slate',
  showHeader = true,
}) => {
  const [isMobileSidebarOpen, setIsMobileSidebarOpen] = useState(false);
  const guide = guideKey ? CLIENT_PAGE_GUIDES[guideKey] : null;

  return (
    <ProductShell className="min-h-screen bg-canvas pb-16 transition-colors lg:pb-0">
      <div className="page-container px-4 py-5 sm:px-6 sm:py-6 md:py-8">
        <div className="flex flex-col gap-5 lg:flex-row lg:gap-6">
          <ClientSidebar
            isMobileOpen={isMobileSidebarOpen}
            onClose={() => setIsMobileSidebarOpen(false)}
          />

          <div className="w-full min-w-0 flex-1 space-y-5">
            {showHeader && title ? (
              <>
                <ClientPageHeader title={title} subtitle={subtitle} actions={actions} />
                {guide ? (
                  <ClientGuideCallout
                    title={guide.title}
                    steps={guide.steps}
                    tone={guideTone}
                  />
                ) : null}
              </>
            ) : null}
            {children}
          </div>
        </div>
      </div>

      <ClientBottomNav />
    </ProductShell>
  );
};

export default ClientPageLayout;
